
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { Loading, OrdiniMTMList, OrdiniMTMCards, LoadingTemplateType } from '@/components';
import { OrdineMTMTestata, Utente, FinderOrdiniMTM } from '@/models';
import { FiltriOrdiniMTM, store, StoreActions, StoreMutations } from '@/store';

@Component({
  components: {
    Loading,
    OrdiniMTMList,
    OrdiniMTMCards
  }
})
export default class OrdiniMTM extends Vue {

  get loading() { return store.state.loading; }

  get user() { return store.state.currentUsr; }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  private templates = LoadingTemplateType;

  get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

  get page(): number { return store.state.uiOrdiniMTM.pagina; }
  set page(value: number) { this.caricaPaginaOrdini(value); } //store.commit(StoreMutations.SetPaginaListaOrdini, value); }

  get pageCount(): number { return store.state.uiOrdiniMTM.totPagine; }
  get numTotOrdini(): number { return store.state.uiOrdiniMTM.totOrdini; }

  get vistaLista(): boolean { return store.state.uiOrdiniMTM.listView; }

  get ordini(): OrdineMTMTestata[] {
    return store.state.listaOrdiniMTM;
  }

  get fornitori(): Utente[] {
    return store.state.fornitori;
  }

  get fornitore(): Utente | undefined {
    return store.state.fornitore;
  }

  get loadTemplateCorrente() : LoadingTemplateType {
    return store.state.uiOrdiniMTM.listView ? LoadingTemplateType.TwoLineAvatarList : LoadingTemplateType.Card;
  }

  set fornitore(fornitore: Utente | undefined) {
    store.commit(StoreMutations.SetFornitore, fornitore);
    if (fornitore) {
      this.idFornitore = fornitore.id;
      this.caricaPaginaOrdini(fornitore.id == store.state.fornitore?.id ? store.state.uiOrdiniMTM.pagina : 1);
    } else {
      this.idFornitore = '';
      store.commit(StoreMutations.SetOrdiniMTM, []);
    }
    //store.dispatch(StoreActions.GetDatiLookupFornitore, this.idFornitore);
  }

  private idFornitore: string = '';

  created(): void {
    if (this.userIsAdmin) {
      console.log(store.state);
      if(store.state.fornitore){
        this.fornitore = store.state.fornitore;
      } else{
        this.fornitore = undefined;
      }
      store.dispatch(StoreActions.GetFornitori);
    } else {
      this.idFornitore = this.user.idFornitore;
      this.caricaPaginaOrdini(store.state.uiOrdiniMTM.pagina);
    }
  }

  private caricaPaginaOrdini(pagina: number): void {

    let parametri: FinderOrdiniMTM = new FinderOrdiniMTM(this.idFornitore, pagina);

    parametri.ApplicaFiltriOrdini(store.state.uiOrdiniMTM.filtri);

    store.dispatch(StoreActions.GetOrdiniMTM, parametri);
  }

  @Watch("$store.state.uiOrdiniMTM.filtri")
  onCambioFiltri(filtriNew: FiltriOrdiniMTM) {
    if(this.idFornitore){
      this.caricaPaginaOrdini(store.state.uiOrdiniMTM.pagina);
    }
  }

  private mounted() {
    //store.dispatch(StoreActions.WatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }

  private destroyed() {
    //store.dispatch(StoreActions.UnwatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }
}
